export const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

export const FORM_PRODUCTO = {
  seccionId: "",
  nombre: "",
  descripcion: "",
  precio: "",
  disponible: true,
};

export const FORM_PROMO = {
  dia: "Lunes",
  descripcion: "",
  precio: "",
  incluye: [],
  activa: true,
};

// Valores "planos" del formulario de sección (ver Utilities/Admin/seccionForm.js)
export const FORM_SECCION = {
  nombre: "",
  padreId: "",
  eyebrow: "",
  navLabel: "",
  activa: true,
  // Productos
  lista: "tarjetas",
  itemsTitulo: "",
  itemsTituloDesde: false,
  // Precios
  precios: [],
  mostrarTablaPrecios: false,
  tituloTabla: "",
  encabezado: "",
  descripcion: "",
  // Extras (ej. orilla de queso)
  extrasActivo: false,
  extrasTitulo: "",
  extrasDestacado: "",
  extrasOpciones: [],
  // Fotos y diseño
  imagenes: [],
  overlayActivo: true,
  overlayLabel: "Desde",
  overlaySub: "",
  fotoLado: "izq",
  anchoFoto: "6",
  fotoTamano: "normal",
  overlayArriba: false,
  variante: "",
};

export const LISTAS = [
  { value: "tarjetas", label: "Tarjetas con precio" },
  { value: "tarjetas-compactas", label: "Tarjetas compactas" },
  { value: "lista", label: "Lista (nombre + ingredientes)" },
  { value: "chips", label: "Chips (sabores / toppings)" },
];

export const FOTO_TAMANOS = [
  { value: "normal", label: "Normal" },
  { value: "md", label: "Mediana" },
  { value: "tall", label: "Alta" },
];
